import clsx from 'clsx';
import { useCallback, useContext, useState, createContext } from 'react';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SegmentedControlContext = /*#__PURE__*/createContext({
  value: '',
  disabled: false,
  onValueChange: () => null
});

const SegmentedControl = _ref => {
  let {
    size = 'medium',
    defaultValue = '',
    className,
    disabled = false,
    children,
    onChange
  } = _ref;
  const {
    0: value,
    1: setValue
  } = useState(defaultValue);
  const handleValueChange = useCallback(changed => {
    setValue(changed);
    typeof onChange === 'function' && onChange(changed);
  }, [onChange]);
  return /*#__PURE__*/_jsx(SegmentedControlContext.Provider, {
    value: {
      value,
      disabled,
      onValueChange: handleValueChange
    },
    children: /*#__PURE__*/_jsx("div", {
      className: clsx(styles.container, {
        [styles[`container--${size}`]]: Boolean(size)
      }, className),
      children: children
    })
  });
};

const Segment = _ref2 => {
  let {
    value,
    leftIcon,
    label,
    badge,
    onClick
  } = _ref2;
  const {
    value: activeValue,
    disabled,
    onValueChange
  } = useContext(SegmentedControlContext);
  const isActive = value === activeValue;
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    className: clsx(styles.segment, {
      [styles['segment--active']]: isActive,
      [styles['segment--disabled']]: disabled
    }),
    onClick: e => {
      if (typeof onClick === 'function') {
        onClick(e);
      } else {
        onValueChange(value);
      }
    },
    children: [leftIcon ? /*#__PURE__*/_jsx("span", {
      className: styles.icon,
      children: leftIcon
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("span", {
      className: styles.label,
      children: label
    }), badge ? /*#__PURE__*/_jsx("span", {
      className: styles.badge,
      children: badge
    }) : /*#__PURE__*/_jsx(_Fragment, {})]
  });
};

export default SegmentedControl;
export { Segment };